const commonRoot = "";
export const PATHS = {
  profile: `${commonRoot}/profile`,
  wallet: `${commonRoot}/wallet`,
  rentals: `${commonRoot}/rentals`,
  listings: `${commonRoot}/listings`,
  orderHistory: `https://commonthreads.com/account`,
  refer: `${commonRoot}/refer`,
  settings: `${commonRoot}/settings`,
};
